import {ButtomStyled} from '../../../styles';
import React from 'react';
import LoadingBar from '../../../components/loadingBar';
import {useIntl} from 'react-intl';

const FooterActions = ({theme, setOuter, loading}) => {
  const intl = useIntl();
  return (
    <div className="d-flex justify-content-end mt-3">
      {loading ? (
        <LoadingBar />
      ) : (
        <>
          <ButtomStyled
            theme={theme}
            className="custom-shadow custom-border btn-theme"
            outline
            type="submit"
            onClick={(_) => setOuter('export')}
          >
            <span>{intl.formatMessage({id: 'reportExport'})}</span>
          </ButtomStyled>
          <ButtomStyled
            theme={theme}
            className="custom-shadow custom-border btn-theme mx-3"
            outline
            type="submit"
            onClick={(_) => setOuter('pdf')}
          >
            <span>{intl.formatMessage({id: 'reportExportPdf'})}</span>
          </ButtomStyled>
          <ButtomStyled
            theme={theme}
            className="custom-shadow custom-border btn-theme mx-3"
            outline
            type="submit"
            onClick={(_) => setOuter('mail')}
          >
            <span>{intl.formatMessage({id: 'reportSendByEmail'})}</span>
          </ButtomStyled>
          <ButtomStyled
            theme={theme}
            className="custom-shadow custom-border btn-theme"
            outline
            type="submit"
            onClick={(_) => setOuter(null)}
          >
            <span>{intl.formatMessage({id: 'reportGoTo'})}</span>
          </ButtomStyled>
        </>
      )}
    </div>
  );
};

export default FooterActions;
